import { render, staticRenderFns } from "./Aka.vue?vue&type=template&id=71a71f3d&scoped=true&"
import script from "./Aka.vue?vue&type=script&lang=js&"
export * from "./Aka.vue?vue&type=script&lang=js&"
import style0 from "./Aka.vue?vue&type=style&index=0&id=71a71f3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a71f3d",
  null
  
)

export default component.exports